var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonalStorage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 35.7,
    fill: "none",
    width: 1.9,
    height: 0.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33.1,
    y: 35.7,
    fill: "none",
    width: 1.9,
    height: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M32.7,37.3h2.7c0.2,0,0.4-0.1,0.4-0.3v-1.3H37c0.2,0,0.3-0.2,0.3-0.4V8.1c0-0.2-0.1-0.4-0.3-0.4H8.1 c-0.2,0-0.4,0.2-0.4,0.4v27.2c0,0.2,0.2,0.4,0.4,0.4h1.1V37c0,0.2,0.2,0.3,0.4,0.3h2.7c0.2,0,0.4-0.1,0.4-0.3v-1.3h19.7V37 C32.4,37.2,32.5,37.3,32.7,37.3L32.7,37.3z M35,36.6h-1.9v-0.9H35V36.6z M11.9,36.6H10v-0.9h1.9L11.9,36.6z M8.4,34.9V8.4H17v26.5 H8.4z M17.7,34.9V8.4h9.6v26.5H17.7z M28,34.9V8.4h8.6v26.5H28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M27.3,8.4h-9.6v26.5h9.6V8.4z M24.1,24.9V24c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4v0.9 c0,0.2-0.2,0.4-0.4,0.4C24.3,25.3,24.1,25.1,24.1,24.9C24.1,24.9,24.1,24.9,24.1,24.9z M24.5,13h-4.1c-0.2,0-0.4-0.1-0.4-0.3 c0-0.2,0.2-0.4,0.4-0.4h4.1c0.2,0,0.4,0.2,0.4,0.4C24.9,12.9,24.7,13,24.5,13z M24.9,14.1c0,0.2-0.2,0.4-0.4,0.4h-4.1 c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h4.1C24.7,13.7,24.9,13.9,24.9,14.1C24.9,14.1,24.9,14.1,24.9,14.1z M20.4,15.2h4.1 c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.3-0.4,0.3h-4.1c-0.2,0-0.4-0.1-0.4-0.3C20,15.4,20.2,15.2,20.4,15.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M17,8.4H8.4v26.5H17V8.4z M14.3,24c0-0.2,0.1-0.4,0.3-0.4c0.2,0,0.4,0.2,0.4,0.4v0.9c0,0.2-0.2,0.4-0.4,0.4 c-0.2,0-0.3-0.2-0.3-0.4V24z M15,12.7c0,0.2-0.2,0.3-0.4,0.3h-4c-0.3,0-0.4-0.1-0.4-0.3c0-0.2,0.2-0.4,0.4-0.4c0,0,0,0,0,0h4 C14.8,12.3,15,12.5,15,12.7L15,12.7z M10.6,13.7h4c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4h-4c-0.2,0-0.4-0.2-0.4-0.4l0,0 C10.2,13.9,10.4,13.7,10.6,13.7C10.6,13.7,10.6,13.7,10.6,13.7z M10.6,15.2h4c0.2,0,0.4,0.2,0.4,0.4l0,0c0,0.2-0.2,0.3-0.4,0.3h-4 c-0.3,0-0.4-0.1-0.4-0.3C10.2,15.4,10.4,15.2,10.6,15.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A1A1",
    d: "M36.6,8.4H28v26.5h8.6V8.4z M34,24.9V24c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.3,0.2,0.3,0.4v0.9 c0,0.2-0.1,0.4-0.3,0.4C34.2,25.3,34,25.1,34,24.9z M34.5,13h-4c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.3,0.4-0.3h4 c0.2,0,0.4,0.1,0.4,0.3C34.9,12.8,34.7,13,34.5,13z M34.9,14.1c0,0.2-0.2,0.4-0.4,0.4h-4c-0.2,0-0.4-0.2-0.4-0.4 c0-0.2,0.2-0.4,0.4-0.4h4C34.7,13.7,34.9,13.9,34.9,14.1C34.9,14.1,34.9,14.1,34.9,14.1z M30.5,15.2h4c0.2,0,0.4,0.2,0.4,0.4 c0,0.2-0.2,0.3-0.4,0.3h-4c-0.2,0-0.4-0.1-0.4-0.3C30.1,15.4,30.3,15.2,30.5,15.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M24.5,12.3h-4.1c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.3,0.4,0.3h4.1c0.2,0,0.4-0.1,0.4-0.3 C24.9,12.5,24.7,12.3,24.5,12.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M24.5,13.7h-4.1c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h4.1c0.2,0,0.4-0.2,0.4-0.4 C24.9,13.9,24.7,13.7,24.5,13.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M20.4,15.9h4.1c0.2,0,0.4-0.1,0.4-0.3c0-0.2-0.2-0.4-0.4-0.4h-4.1c-0.2,0-0.4,0.2-0.4,0.4 C20,15.8,20.2,15.9,20.4,15.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M34.5,12.3h-4c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.2,0.4,0.4,0.4h4c0.2,0,0.4-0.2,0.4-0.4 C34.9,12.4,34.7,12.3,34.5,12.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M34.5,13.7h-4c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h4c0.2,0,0.4-0.2,0.4-0.4 C34.9,13.9,34.7,13.7,34.5,13.7z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M30.5,15.9h4c0.2,0,0.4-0.1,0.4-0.3c0-0.2-0.2-0.4-0.4-0.4h-4c-0.2,0-0.4,0.2-0.4,0.4 C30.1,15.8,30.3,15.9,30.5,15.9z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M10.6,12.3c-0.2,0-0.4,0.2-0.4,0.4l0,0c0,0.2,0.1,0.3,0.4,0.3h4c0.2,0,0.4-0.1,0.4-0.3 c0-0.2-0.2-0.4-0.4-0.4l0,0H10.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M10.6,14.5h4c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4h-4c-0.2,0-0.4,0.2-0.4,0.4l0,0 C10.2,14.3,10.4,14.5,10.6,14.5C10.6,14.5,10.6,14.5,10.6,14.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M10.6,15.9h4c0.2,0,0.4-0.1,0.4-0.3c0-0.2-0.2-0.4-0.4-0.4l0,0h-4c-0.2,0-0.4,0.2-0.4,0.4l0,0 C10.2,15.8,10.3,15.9,10.6,15.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M14.6,25.3c0.2,0,0.4-0.2,0.4-0.4V24c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.3,0.2-0.3,0.4v0.9 C14.3,25.1,14.4,25.3,14.6,25.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M24.9,24.9V24c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4v0.9c0,0.2,0.2,0.4,0.4,0.4 C24.7,25.3,24.9,25.1,24.9,24.9C24.9,24.9,24.9,24.9,24.9,24.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M34.7,24.9V24c0-0.2-0.1-0.4-0.3-0.4c-0.2,0-0.4,0.2-0.4,0.4v0.9c0,0.2,0.2,0.4,0.4,0.4 C34.6,25.3,34.7,25.1,34.7,24.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalStorage);
export default __webpack_public_path__ + "static/media/personal_storage.8410356913bf6a2b9052bc2cd950af50.svg";
export { ForwardRef as ReactComponent };